import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ee1d6d76&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ee1d6d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d6d76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1d6d76')) {
      api.createRecord('ee1d6d76', component.options)
    } else {
      api.reload('ee1d6d76', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ee1d6d76&scoped=true&", function () {
      api.rerender('ee1d6d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJ4vR5LCpPvF/JS/comp/PopupBox.vue"
export default component.exports